'use client';

import { useContext, useEffect } from 'react';
import { AuthContext } from 'src/context/auth-context/auth-context';
import { clearDatadogUser, identifyDatadogUser } from 'src/lib/datadog';

const DatadogUserIdentifier = () => {
	const [userDetails] = useContext(AuthContext);

	useEffect(() => {
		if (!userDetails?.property_manager_id) {
			clearDatadogUser();
			return;
		}

		const displayName = [userDetails.first_name, userDetails.last_name]
			.filter(Boolean)
			.join(' ')
			.trim();

		identifyDatadogUser({
			propertyManagerId: userDetails.property_manager_id,
			displayName,
			email: userDetails.email,
		});
	}, [userDetails]);

	return null;
};

export default DatadogUserIdentifier;
